export enum GoToTeamSectionButtonNavigationType {
	GoToIndex = 'go-to-index',
	GoToTop = 'go-to-top'
}
